import FormInput from "@/components/forms/FormInput";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { useCreateHeroModelMutation } from "@/app/features/HeroModel/HeroModelApiSlice";

const initialValues = {
  carId: "",
};

const validationSchema = Yup.object().shape({
  carId: Yup.string().required().max(50).label("carId").trim(),
});

export default function CreateHeroModelPage() {
  const [createPost, { isLoading }] = useCreateHeroModelMutation();

  const navigate = useNavigate();

  const handleSubmit = async (inputs) => {
    try {
      const result = await createPost({ carId: inputs.carId });

      if (result && result.data) {
        toast.success(result.data.message);
        navigate("/hero-model");
      } else if (result && result.error) {
        toast.error(result.error.data.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Create Hero Model</Typography>
          </Stack>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({
              setFieldValue,
              values,
              setFieldTouched,
              setFieldError,
              errors,
              resetForm,
            }) => (
              <Form>
                <Stack spacing={3}>
                  <FormInput
                    label="carId"
                    name="carId"
                    type="text"
                    placeholder="Enter carId"
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                  >
                    Submit
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </Container>
    </Box>
  );
}
